import React from "react"
import { componentStyles, useTheme } from "@mallardbay/lib-react-components"

import type { AmenityFieldsFragment } from "~graphql/generated/graphql"
import PageSectionHeading from "~components/shared/typography/page-section-heading"
import Box from "~components/shared/todo-lib-react-components/box"
import ImageTag from "~components/shared/todo-lib-react-components/image-tag"
import Divider from "~components/shared/todo-lib-react-components/divider"

interface Props {
    readonly title: string
    readonly amenities: AmenityFieldsFragment[]
    readonly shouldRenderDivider?: boolean
}

export default function ListingAmenitiesListByCategory({
    title,
    amenities,
    shouldRenderDivider,
}: Props) {
    const styles = useStyles()

    if (!amenities.length) return null

    return (
        <>
            <PageSectionHeading label={title} />
            <Box style={styles.amenityWrapper}>
                {amenities.map((amenity) => {
                    return (
                        <ImageTag
                            key={amenity.id}
                            imageSrc={amenity.icon_url}
                            imageAlt={amenity.name}
                            imageStyle={styles.amenityIcon}
                            style={styles.tag}
                        >
                            {amenity.name}
                        </ImageTag>
                    )
                })}
            </Box>
            {shouldRenderDivider && <Divider style={styles.divider} />}
        </>
    )
}

function useStyles() {
    const { isDarkMode, colors } = useTheme()

    return componentStyles({
        amenityWrapper: {
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            gap: "10px",
        },
        amenityIcon: {
            width: "20px",
            height: "20px",
            filter: isDarkMode
                ? "invert(86%) sepia(0%) hue-rotate(176deg) brightness(84%) contrast(83%)"
                : "initial",
        },
        amenityText: {
            fontWeight: 300,
        },
        tag: {
            backgroundColor: colors.backgroundSecondary,
            borderColor: colors.backgroundSecondary,
            width: "fit-content",
        },
        divider: {
            marginTop: 4,
        },
    })
}
